import {
  isPeselMatchingLicenseDate,
  IsPeselMatchingLicenseDateFunctionParams,
  isPeselValid,
} from 'app/services/pesel.service';
import { setMessageVisibility } from 'app/services/businessFunctionHelpers';
import { FormsEnum, MessagesEnum } from 'app/shared/enums';

interface CheckIfPeselIsMatchingLicenseDateInterface
  extends IsPeselMatchingLicenseDateFunctionParams {
  messageKey: MessagesEnum;
  formName: FormsEnum;
}

export default function checkIfPeselIsMatchingLicenseDate(
  data: CheckIfPeselIsMatchingLicenseDateInterface
) {
  const { formName, messageKey, pesel } = data;
  const isMatching = isPeselMatchingLicenseDate(data);

  setMessageVisibility({
    key: messageKey,
    visible: isPeselValid(pesel) && !isMatching,
    formName,
  });
}
